/*
* Copyright (C) Regione Lombardia
*/
export enum OperaStatoEnum {
    BOZZA = 1,
    COMPLETATA = 2,
    VERIFICATA = 3,
    ELIMINATA = 4,
}
